import { useState, useEffect } from "react";
import styled from "styled-components";
import { getOwnershipMarkersList, deleteMarkerById } from "./Utility.js";
import toast from "react-hot-toast";
import { t } from "@lingui/core/macro";

const Link = styled.a`
  display: inline;
  align-items: center;
  color: #bf4f74;
  cursor: pointer;
`;

const UnorderedList = styled.ul`
  list-style: none;
  width: 100%;
  text-align: left;
  height: 50vh;
  overflow-y: scroll;
  li {
    margin-bottom: 7px;
    display: flex;
    flex-direction: column;
    width: 100%;
    border-bottom: 1px dotted;
  }
`;

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 90%;
`;
const StyledDescription = styled.span`
  color: #bf4f74;
`;
const StyledW3w = styled.span`
  color: #bf4f74;
`;
const StyledImages = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1vh;
  img {
    width: 32px;
    height: 32px;
  }
`;
const StyledActions = styled.div`
  display: flex;
  flex-direction: row-reverse;
  gap: 1vh;
  span {
    width: 32px;
    height: 32px;
  }
`;

/**
 * A component that displays of own stories
 *
 * @param {string} props
 * @returns {JSX.Element}
 */
export function ListOwnership(options) {
  const [list, setList] = useState([]);

  /**
   * A function that manages a single story click
   * @param {object} story - A clicked story object
   * @returns {void} Call a prop function
   */
  const handleClickEditOwn = (story) => {
    if (options && options.editOwn) {
      options.editOwn(story);
    }
  };

  /**
   * A function that manages a single story deletion
   * @param {string} id - A clicked story id
   * @returns {void} Call a function to erase a story
   */
  const handleClickDeleteOwn = (id) => {
    deleteMarkerById(id)
      .then((data) => {
        if (data.success) {
          toast(t`Story successfully deleted!`, {
            icon: "👋",
          });
          refreshOwnershipMarkerList();
        }
      })
      .catch((error) =>
        toast(t`This history cannot be erased!`, {
          icon: "🥵",
        })
      );
  };

  /**
   * A function that update the list of own stories
   * @returns {void} Set a variable of state
   */
  const refreshOwnershipMarkerList = () => {
    getOwnershipMarkersList()
      .then((response) => {
        if (response.success) {
          setList(response.data);
        }

        if (response.success === false) {
          toast(t`Problems getting your stories`, {
            icon: "🥵",
          });
        }
      })
      .catch((e) => {});
  };

  // Refresh the list of own stories
  useEffect(() => {
    refreshOwnershipMarkerList();
  }, [options.drawerOpened]);

  return (
    <div>
      <StyledWrapper>
        <UnorderedList>
          {list && list.length > 0 ? (
            list.map((offer, index) => (
              <li key={index}>
                <StyledActions>
                  {" "}
                  <Link url="#" onClick={() => handleClickEditOwn(offer)}>
                    ✏️
                  </Link>
                  <Link onClick={() => handleClickDeleteOwn(offer._id)} url="#">
                    🪣
                  </Link>
                </StyledActions>
                <StyledDescription>{offer.descriptionGive}</StyledDescription>
                <StyledW3w>{offer.w3wData.address}</StyledW3w>
                <StyledImages>
                  {offer.photos.map((photo, index) => (
                    <img alt="" src={photo.url} />
                  ))}
                </StyledImages>
              </li>
            ))
          ) : (
            <li>{t`You don't have any stories yet`}</li>
          )}
        </UnorderedList>
      </StyledWrapper>
    </div>
  );
}

export default ListOwnership;
